import { useCallback } from 'react';
import { SkinnedMobileBottomNav } from '../../config/skinRegistry/components';
import { useShellNavigationOptions } from '../../hooks/components/useShellNavigationOptions';

type MobileBottomNavShellProps = {
  isDrawerOpen: boolean;
  toggleDrawerVisibility: (isOpen: boolean) => void;
};

const MobileBottomNavShell = ({ isDrawerOpen, toggleDrawerVisibility }: MobileBottomNavShellProps) => {
  const { showSearchEntry } = useShellNavigationOptions();

  const toggleDrawer = useCallback(() => {
    toggleDrawerVisibility(!isDrawerOpen);
  }, [isDrawerOpen, toggleDrawerVisibility]);

  return (
    <SkinnedMobileBottomNav showSearchEntry={showSearchEntry} isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
  );
};

export default MobileBottomNavShell;
